import React, { useEffect } from 'react';
import { initialState, referralPageReducer, ReferralPageActionState, ReferralPageAction } from 'placement/reducers/referralPage';
import { PlacementPage } from '../../components/PlacementPage';
import { parseISO } from 'date-fns';
import { PAGE } from 'placement/const';

export function getPlacementPageFromSessionStorage(): PAGE {
    const storedValue = sessionStorage.getItem('internalPlacementPage');
    const parsedState = storedValue ? JSON.parse(storedValue) : initialState();
    return parsedState.page;
}

function useSessionReducer(
  reducer: (state: ReferralPageActionState, action: ReferralPageAction) => ReferralPageActionState,
  initialState: ReferralPageActionState,
  key: string
) {
  const [state, dispatch] = React.useReducer(reducer, initialState, (init) => {
    try {
      const storedValue = sessionStorage.getItem(key);
      const parsedState = storedValue ? JSON.parse(storedValue) : init;
      
      // Process filter with date conversions if it exists
      let filter = init.filter!;
      if (parsedState.filter) {
        filter = {
          ...parsedState.filter,
          // Convert date strings back to Date objects
          ...(parsedState.filter.referralSubmittedFrom && {
            referralSubmittedFrom: parseISO(parsedState.filter.referralSubmittedFrom)
          }),
          ...(parsedState.filter.referralSubmittedTo && {
            referralSubmittedTo: parseISO(parsedState.filter.referralSubmittedTo)
          })
        };
      }
      
      // Return state with persisted values or defaults
      return {
        page: parsedState.page ?? init.page,
        sortBy: parsedState.sortBy ?? init.sortBy,
        pagination: parsedState.pagination ?? init.pagination,
        filter,
        currentCursor: parsedState.currentCursor ?? init.currentCursor,
        showDetailModal: false,
        showMatchModal: false,
        selectedReferral: null,
        referrals: [],
        selectedOfferGuids: [],
        offerConversationOnly: parsedState.offerConversationOnly ?? init.offerConversationOnly,
      };
    } catch (error) {
      // Return default state on error
      return {
        page: init.page,
        sortBy: init.sortBy,
        pagination: init.pagination,
        filter: init.filter!,
        currentCursor: init.currentCursor,
        showDetailModal: false,
        showMatchModal: false,
        selectedReferral: null,
        referrals: [],
        selectedOfferGuids: [],
        offerConversationOnly: init.offerConversationOnly,
      };
    }
  });

  // Persist selected state fields to session storage
  useEffect(() => {
    const persistedState = {
      page: state.page,
      sortBy: state.sortBy,
      pagination: state.pagination,
      filter: state.filter,
      currentCursor: state.currentCursor,
      offerConversationOnly: state.offerConversationOnly
    };
    sessionStorage.setItem(key, JSON.stringify(persistedState));
  }, [key, state.filter, state.sortBy, state.pagination, state.page, state.currentCursor, state.offerConversationOnly]);

  return { state, dispatch };
}



export const SessionStoredPlacementPage = () => {
    const {state, dispatch} = useSessionReducer(referralPageReducer, initialState(), 'internalPlacementPage');

    return (
        <PlacementPage appState={state} dispatch={dispatch}/>
    );
};